import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import Login from './components/Login';
import Modal from '../../components/Modal/Modal';
import { AuthContext } from '../../context/Auth/Auth';
import modalReducer, { initialState } from '../../reducers/Modal.reducer';
import { getReturnUrlFromSearch } from '../../utils/returnUrl';

const Loginpage = () => {
  const [state, dispatch] = React.useReducer(modalReducer, initialState);
  const { isLoggedIn } = React.useContext(AuthContext);
  const { search } = useLocation();
  const returnUrl = getReturnUrlFromSearch(search);

  const closeModal = React.useCallback(() => {
    dispatch({ type: 'CLOSE_MODAL' });
  }, []);

  const showModalError = React.useCallback((errorMessage: string) => {
    dispatch({ type: 'SHOW_MODAL_ERROR', payload: errorMessage });
  }, []);

  return (
    <React.Fragment>
      {isLoggedIn ? (
        <Redirect to={returnUrl} />
      ) : (
        <React.Fragment>
          <Login showModalError={showModalError} returnUrl={returnUrl} />
          <Modal show={state.showModal} error={state.error} errorMessage={state.errorMessage} closeModal={closeModal} />
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default Loginpage;
